import { apiRequest } from "../../utils/apiUtils";

export const advertisementApi = {
  getAdvertisements: () =>
    apiRequest<any>("get", "/advertisement-video/list", { fullResponse: true }),
};
